import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { Text, Button, Announcement } from 'mintel-react-ui';

import useTranslation from '../../translations';
import { HELPDESK_EMAIL } from '../../shared/constants';
import { changeLanguage } from '../../shared/utils';
import { DjangoPageMessages } from '../../fields';
import PageWrapper from '../../PageWrapper';
import styles from './RegisterForAccess.scss';

export type RegisterForAccessProps = DjangoPageMessages & {
  resendUrl: string;
  language?: string;
  announcementType?: 'info' | 'alert' | null;
};

const RegisterForAccess = ({
  resendUrl,
  language = 'en',
  announcementType = null,
  errors = [],
  info = [],
}: RegisterForAccessProps): JSX.Element => {
  const { t } = useTranslation();
  useEffect(() => {
    changeLanguage(language);
  }, [language]);

  return (
    <PageWrapper errors={errors} infos={info}>
      {announcementType && (
        <Announcement
          mode={announcementType}
          label={t('The link you clicked has already been used')}
          overflow
          showCloseButton={false}
          onClose={() => {
            // announcements shouldn't be closable
          }}
        />
      )}
      <form method="POST" className={styles.root}>
        <div className={styles.title}>
          <Text.Heading2>{t('Register for access')}</Text.Heading2>
        </div>
        <div className={styles.description}>
          <Text.Body2>
            <Trans>
              Click the resend button and we&apos;ll send you another email with
              a new link. If you&apos;re still having trouble, please get in
              touch with our <a href={`mailto:${HELPDESK_EMAIL}`}>Helpdesk</a>.
            </Trans>
          </Text.Body2>
        </div>
        <div className={styles.buttonRow}>
          <div className={styles.button}>
            <Button.ActionButton
              type="submit"
              fullWidth
              handleClick={() => {
                window.location.pathname = resendUrl;
              }}
              status={Button.Status.DEFAULT}
            >
              {t('Resend')}
            </Button.ActionButton>
          </div>
        </div>
      </form>
    </PageWrapper>
  );
};

export default RegisterForAccess;
